var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2703 6.36843H1.00709C0.777242 6.36692 0.557236 6.27494 0.394703 6.1124C0.23217 5.94987 0.140189 5.72986 0.138672 5.50001C0.140189 5.27016 0.23217 5.05016 0.394703 4.88762C0.557236 4.72509 0.777242 4.63311 1.00709 4.63159H10.2703C10.5001 4.63311 10.7201 4.72509 10.8826 4.88762C11.0452 5.05016 11.1372 5.27016 11.1387 5.50001C11.1372 5.72986 11.0452 5.94987 10.8826 6.1124C10.7201 6.27494 10.5001 6.36692 10.2703 6.36843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63795 11C5.4081 10.9985 5.1881 10.9065 5.02556 10.744C4.86303 10.5814 4.77105 10.3614 4.76953 10.1316V0.868421C4.77105 0.63857 4.86303 0.418564 5.02556 0.256031C5.1881 0.0934985 5.4081 0.00151722 5.63795 0C5.8678 0.00151722 6.08781 0.0934985 6.25034 0.256031C6.41287 0.418564 6.50486 0.63857 6.50637 0.868421V10.1316C6.50486 10.3614 6.41287 10.5814 6.25034 10.744C6.08781 10.9065 5.8678 10.9985 5.63795 11Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0.138672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.bede5dca7dfa1f03157fe2391083b86a.svg";
export { ForwardRef as ReactComponent };